module.exports = "https://coursera_assets.s3.amazonaws.com/images/685ca8494a84d17f8ef53a3c04418aca.png";